import moment from 'moment';
import { SubscriptionTypeEnum } from '../types/HowTos';

export const customFormatDate = (dateString = 0) => {
  return moment(dateString).format('DD.MM.YYYY');
};

export const customFormatTime = (dateString = 0) => {
  return moment(dateString).format('HH:mm');
};

export const shouldShowUpgradeProBanner = ({
  subscriptionType,
  instructionLeft,
}: {
  subscriptionType: SubscriptionTypeEnum;
  instructionLeft: number;
}): Boolean => {
  if (subscriptionType === SubscriptionTypeEnum.FREE) {
    if (instructionLeft <= 2) {
      return true;
    }
    return false;
  }
  return false;
};

export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
